import * as React from 'react';

import { getFillProgress } from './getFillProgress';
import { IFIOSuggestContainerProps } from '../FIOSuggestContainer';

export interface IParams {
  onChange: IFIOSuggestContainerProps['onChange'];
  inputValue: string;
}

export const useInputValueSubscribe = (params: IParams) => {
  const { onChange, inputValue } = params;

  React.useEffect(() => {
    const inputSplitValue = inputValue.split(' ');

    const fillProgress = getFillProgress(inputSplitValue);

    onChange(inputValue, fillProgress);
  }, [onChange, inputValue]);
};
